import cn from 'classnames'
import React, { useState } from 'react'
import { IContentItemFragment, IContentListItemFragment } from 'src/graphql/generated/hooks'

import { ContentListItem } from '../ContentList/ContentListItem/ContentListItem'

export interface ShareResourceListProps {
  items: (IContentItemFragment | IContentListItemFragment | any)[]
  showDocumentType?: boolean
  className?: string
  searchKeyword?: string
}

export const ShareResourceList: React.FC<ShareResourceListProps> = ({
  items,
  showDocumentType = false,
  className = '',
  searchKeyword,
}) => {
  const [openTooltipCardId, setOpenTooltipCardId] = useState<string | null>(null)

  return (
    <div className={cn(className, 'bg-white', 'border-y', 'border-zinc-300')}>
      <ul className="divide-y divide-zinc-300">
        {items.map((item, index) => {
          return (
            <li key={index}>
              <ContentListItem
                openTooltipCardId={openTooltipCardId}
                setOpenTooltipCardId={setOpenTooltipCardId}
                item={item}
                showDocumentType={showDocumentType}
                searchKeyword={searchKeyword}
              />
            </li>
          )
        })}
      </ul>
    </div>
  )
}
